<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet } from '@ionic/vue';
// import { App } from '@capacitor/app';

export default {
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
  },
  // mounted() {
  //   this.requestRuntimePermissions();
  // },
  // methods: {
  //   async requestRuntimePermissions() {
  //     try {
  //       // 🎤 Microphone permission
  //       const micPermission = await Permissions.request({ name: 'microphone' });
  //       if (micPermission.state !== 'granted') {
  //         alert('Microphone access is required. Please enable it in system settings.');
  //         App.openSettings(); // Takes user to app settings
  //       }

  //       // 🎵 Media permission (for audio files)
  //       const mediaPermission = await Permissions.request({ name: 'camera' }); // Replace 'camera' with the appropriate permission if needed
  //       if (mediaPermission.state !== 'granted') {
  //         alert('Media file access is required. Please enable it in system settings.');
  //         App.openSettings();
  //       }
  //     } catch (error) {
  //       console.error('Permission request error:', error);
  //     }
  //   },
  // },
};
</script>

<style>
#app {
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffffff;
  height: 100%;
  background-color: black;
}

.no-shadow {
  --box-shadow: none;
  box-shadow: none;
}

html {
  background-color: black;
}
</style>
